// eslint-disable-next-line import/prefer-default-export
export const NEWS_PER_PAGE = 10;
